import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { bootstrapUser } from '@/lib/api';

/**
 * Handles both PKCE (`?code=...`) and magic-link hash flows.
 * On success, ensures wallet row exists, fires welcome email, routes to /dashboard.
 */
export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const { data } = await supabase.auth.getSession();
      if (data.session) {
        try {
          await bootstrapUser();
        } catch {
          /* non-fatal: trigger already seeded on server */
        }

        // Dispara welcome email (Brevo) + adiciona a lista LTD Launch.
        // Idempotente: se ja foi mandado, Brevo apenas atualiza contato.
        try {
          const supaUrl = import.meta.env.VITE_SUPABASE_URL as string;
          const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
          const email = data.session.user.email ?? '';
          const firstRaw = (data.session.user.user_metadata?.full_name as string | undefined)
            ?? email.split('@')[0]
            ?? '';
          const first = firstRaw.split(' ')[0] ?? '';
          if (email) {
            void fetch(`${supaUrl}/functions/v1/welcome-email`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${anon}` },
              body: JSON.stringify({ email, first_name: first }),
              keepalive: true,
            }).catch(() => { /* non-fatal */ });
          }
        } catch {
          /* non-fatal */
        }

        navigate('/dashboard', { replace: true });
      } else {
        navigate('/auth/login', { replace: true });
      }
    };
    void run();
  }, [navigate]);

  return <div className="grid min-h-svh place-items-center text-muted-foreground">Autenticando…</div>;
};
